import React, { useEffect, useState } from 'react';
import axios from 'axios';

const PartnerSlider = ({ show, speed = 40, repeat = 3 }) => {
  const [sliders, setSliders] = useState([]);

  useEffect(() => {
    if (show !== 'yes') return;
    const fetchSliders = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}getPSliders`);
        if (res.data.result === 'ok') {
          const valid = res.data.sliders.filter((s) => s.img);
          if (valid.length === 0) return;

          let extended = [];
          for (let i = 0; i < repeat; i++) {
            extended = extended.concat(valid);
          }

          setSliders(extended);
        }
      } catch (err) {
        console.error('Eroare la slider parteneri', err);
      }
    };

    fetchSliders();
  }, [show, repeat]);

  if (show !== 'yes' || sliders.length === 0) return null;

  return (
    <div className="partner-slider-container">
      <div
        className="partner-slider-track"
        style={{ animationDuration: `${speed}s` }} // aici controlez viteza
      >
        {sliders.map((item, index) => (
          item.action === 'link' && item.link ? (
            <a key={index} href={item.link} target="_blank" rel="noopener noreferrer">
              <img src={item.img} alt={`partner-${index}`} className="partner-slider-image" />
            </a>
          ) : (
            <div key={index}>
              <img src={item.img} alt={`partner-${index}`} className="partner-slider-image" />
            </div>
          )
        ))}
      </div>
    </div>
  );
};

export default PartnerSlider;
